"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get camelToSnake () {
        return camelToSnake;
    },
    get snakeToCamel () {
        return snakeToCamel;
    }
});
const _bson = require("bson");
const _lodash = require("lodash");
/**
 * Check if we should convert the keys of the object or leave as is.
 *
 * This is important for things like ObjectId, which we don't want to convert.
 *
 * Make sure to add a unit test when adding new types.
 */ const isConvertible = (obj)=>{
    // Null or non-object types should not be converted
    if (obj === null || typeof obj !== "object") {
        return false;
    }
    // Don't convert these types
    const unconvertibleTypes = [
        _bson.ObjectId,
        Date
    ];
    if (unconvertibleTypes.some((type)=>obj instanceof type)) {
        return false;
    }
    return true;
};
// skipKeys should match the path of the key to skip, delimited by dots, ignoring array indexes.
const convertKeys = (obj, convertFn, skipKeys = [])=>{
    // Always skip _id
    if (!skipKeys.includes("_id")) {
        skipKeys.push("_id");
    }
    if (!isConvertible(obj)) return obj;
    if (Array.isArray(obj)) {
        return obj.map((item)=>convertKeys(item, convertFn, skipKeys));
    }
    const newObj = {};
    for(const key in obj){
        if (obj.hasOwnProperty(key)) {
            // Convert key to new case
            const newKey = convertFn(key);
            if (skipKeys.includes(key)) {
                // Save values without converting
                newObj[key] = obj[key];
            } else {
                // Save key with recursively converted value
                newObj[newKey] = convertKeys(obj[key], convertFn, skipKeys.map((keyToSkip)=>{
                    // Remove this key prefix from the skipKeys
                    return keyToSkip.replace(new RegExp(`^(${key}|${newKey})\.`), "");
                }));
            }
        }
    }
    return newObj;
};
const snakeToCamel = (obj, skipKeys = [])=>convertKeys(obj, _lodash.camelCase, skipKeys);
const camelToSnake = (obj, skipKeys = [])=>convertKeys(obj, _lodash.snakeCase, skipKeys);
